// Challenge status
export const NOT_STARTED = 'NOT_STARTED';
export const STARTED = 'STARTED';
export const PASSED = 'PASSED';
export const FAILED = 'FAILED';
